<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">

          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select
                [(ngModel)]="params.storeIds"
                [multiple]="true"
                (selectChange)="navigate()">
              </hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select
                [(ngModel)]="params.date"
                (selectChange)="navigate()">
              </hx-date-range-select>
            </div>
          </div>

          <div class="m--margin-top-15">
            <button
              type="button"
              (click)="resetFilter()"
              class="btn btn-outline-primary">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <div *ngIf="list.length && !isLoading.list" class="block-table-scroll m--margin-top-30">
            <table class="m--margin-top-10 m--margin-bottom-40 table-report" style="width:100%; border-collapse: collapse;">
              <thead>
              <tr>
                <th class="text-align-center">{{ 'payment-schedule.table.head.cashflowName' | transloco }}</th>
                <th class="text-align-center">{{ 'payment-schedule.table.head.storeName' | transloco }}</th>
                <th class="text-align-center">{{ 'payment-schedule.table.head.payBefore' | transloco }}</th>
                <th class="text-align-center">{{ 'payment-schedule.table.head.total' | transloco }}</th>
                <th class="text-align-center">{{ 'payment-schedule.table.head.status' | transloco }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let r of list">
                <tr>
                  <td>
                    <a [routerLink]="['../../storage/spendings']" [queryParams]="{ payBeforeFrom: params.date?.from, payBeforeTo: params.date?.to, storeIds: [r.storeId], cashflowCode: r.cashflowCode }">
                      {{ r.cashflowTitle | uiLabel }}
                    </a>
                  </td>
                  <td>{{ r.storeTitle | uiLabel }}</td>
                  <td>{{ r.payBefore | date:'dd.MM.YYYY' }}</td>
                  <td class="txt-right">{{ r.total | number }}</td>
                  <td class="txt-right" [ngClass]="{ 'is--expired': r.status === 'expired', 'is--planned': r.status === 'planned', 'is--paid': r.status === 'paid' }">{{ 'payment-schedule.table.' + r.status | transloco }}</td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

        </div>
      </div>
    </div>
  </div>
</div>
